import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameLogic } from '../../Logic/GameLogic';
import { AnimationContents } from '../../../AnimationContents';

import * as PIXI from 'pixi.js';
import { MiniGameModel } from '../../Models/Game/MiniGameModel';
import { TaskModel, TaskType } from '../../Models/Game/TaskModel';
import { secondsToMMSS } from '../../Common/Utils';

export class UIPointerMiniGameController extends AnimationBaseController {
    $model: MiniGameModel;

    private screenWidth: number = 0;
    private screenHeight: number = 0;

    private _task: TaskModel = null;

    public constructor(@Inject private _options,
                       @Inject private _gameLogic: GameLogic) {
        super('UIPointerMiniGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.POINTER_JSON,
            libraryName: 'pointer',
            modelWatch: {
                screenPos: (value: [number, number]) => {
                    this.updatePosition();
                },
            },
        };
    }

    protected onInitialize(): void {
        this._task = this._gameLogic.getTaskByMiniGameType(this.$model.type);

        this.gotoAndStop(this._task.type === TaskType.Global ? 'task_global' : 'task_regular');
        this.updatePosition();
    }

    protected onResize(width: number, height: number, scale: number) {
        this.screenWidth = width;
        this.screenHeight = height;
    }

    protected onUpdate(frameRate: number) {
        this.setTextByQuery('time', this._task.index.toString());
    }

    protected updatePosition(): void {
        let global = new PIXI.Point(this.$model.screenPos[0], this.$model.screenPos[1]);
        let { x, y } = this.display.parent.toLocal(global, this.renderer.stage);

        const margin = 0;

        let leftTop = this.display.parent.toLocal(new PIXI.Point(margin, margin), this.renderer.stage);
        let rightTop = this.display.parent.toLocal(new PIXI.Point(this.screenWidth - margin, margin), this.renderer.stage);
        let leftBottom = this.display.parent.toLocal(new PIXI.Point(margin, this.screenHeight - margin), this.renderer.stage);

        let allowVisible = true;
        let globalTask = this._gameLogic.getGlobalTask();

        if (globalTask) {
            if (globalTask.miniGameType !== this.$model.type) {
                allowVisible = false;
            }
        }

        if (x - this.display.width / 2 < leftBottom.x) {
            x = leftBottom.x + this.display.width / 2;
        }
        if (x + this.display.width / 2 > rightTop.x) {
            x = rightTop.x - this.display.width / 2;
        }
        if (y - this.display.height / 2 < leftTop.y) {
            y = leftTop.y + this.display.height / 2;
        }
        if (y + this.display.height / 2 > leftBottom.y) {
            y = leftBottom.y - this.display.height / 2;
        }

        this.visible = allowVisible;
        this.x = x;
        this.y = y;
    }
}

